import apiClient from './apiClient';
import {
  ProjectActivityTowerRequest,
  ProjectActivityTowerResponse
} from '../types/projectActivityTowerTypes';

export const assignTowerToActivity = async (
  request: ProjectActivityTowerRequest
): Promise<ProjectActivityTowerResponse> => {
  const response = await apiClient.post('/project-activity-towers', request);
  return response.data;
};

export const removeTowerFromActivity = async (
  projectActivityId: number,
  towerId: number
): Promise<void> => {
  await apiClient.delete('/project-activity-towers', {
    params: {
      projectActivityId,
      towerId
    }
  });
};

export const getTowersByProjectActivity = async (
  projectActivityId: number
): Promise<ProjectActivityTowerResponse[]> => {
  const response = await apiClient.get(
    `/project-activity-towers/activity/${projectActivityId}`
  );

  return response.data;
};

export const getActivityTowerRelationsByProject = async (
  projectId: number
): Promise<ProjectActivityTowerResponse[]> => {
  const response = await apiClient.get(`/project-activity-towers/project/${projectId}`);
  return response.data;
};